<template>
  <!-- 重新设置密码 -->
  <h3 class="mt-5">{{$t('rpmessage.title')}}</h3>
  <el-row justify="center" class="mt-5">
    <el-col :span="19">
      <p style="float: left; font-weight: bold">
        {{$t('rpmessage.mess')}}
      </p>
    </el-col>
  </el-row>
  <el-row justify="center" class="mt-1">
    <el-col :span="19">
      <p style="float: left">
       {{$t('rpmessage.passwdrule')}}
      </p>
    </el-col>
  </el-row>

  <!-- 密码 -->
  <el-row justify="center" class="mt-4">
    <el-col :span="9"
      ><p v-if="passwd != ''" class="utitle">{{$t('rpmessage.passwd')}}</p></el-col
    >
    <el-col :span="1"></el-col>
    <el-col :span="9"
      ><p v-if="confirmpasswd != ''" class="utitle">{{$t('rpmessage.confirmpasswd')}}</p></el-col
    >
  </el-row>
  <el-row
    justify="center"
    :class="[passwd == '' && confirmpasswd == '' ? 'mt-3' : 'mt-0']"
  >
    <el-col :span="9"
      ><el-input
        v-model="passwd"
        type="password"
        :placeholder="$t('rpmessage.passwd')"
        clearable
        @blur="oncheckpasswd"
    /></el-col>
    <el-col :span="1"></el-col>
    <el-col :span="9"
      ><el-input
        v-model="confirmpasswd"
        type="password"
        :placeholder="$t('rpmessage.confirmpasswd')"
        clearable
        @blur="onconfirmpasswd"
    /></el-col>
  </el-row>
  <!-- 密码合法与一致性检验 -->
  <el-row justify="center" class="mt-0">
    <el-col :span="9"
      ><div v-if="!passwdvalidation" class="sfont">
        {{ passwderrmess }}
      </div></el-col
    >
    <el-col :span="1"></el-col>
    <el-col :span="9"
      ><div v-if="!samepasswd" class="sfont">
        {{$t('rpmessage.confirmpasswdvalid')}}
      </div></el-col
    >
  </el-row>

  <el-row justify="start" class="mt-5">
    <el-col :span="1"></el-col>
    <el-col :span="4">
      <el-button class="mb-5" type="primary" @click="onsendresetpasswd"
        >{{$t('rpmessage.send')}}</el-button
      >
    </el-col>
  </el-row>
</template>



<script>
import { ref, computed, reactive, toRefs, onMounted } from "vue";
import { resetpassword } from "../../js/userhandler";
import {des} from "../../js/des"
import { ElMessageBox } from "element-plus";
import { useI18n } from 'vue-i18n'
import { useRouter } from "vue-router";

export default {
  setup() {
    const router=useRouter()
    const passwd = ref("");
    const confirmpasswd = ref("");
    const uid = ref("");
    const {t}=useI18n()
    const state = reactive({
      invalidpasswd: false,
      samepasswd: true,
      submitted: false,
    });
    onMounted(() => {
      uid.value = getQueryString("uid");//从地址栏中取得uid
    });

    const passwdvalidation = computed(() => {
      if (passwd.value.length == 0 && !state.submitted) return true;

      if (passwd.value.length < 8) return false;
      else return true;
    });
    const passwderrmess = computed(() => {
      if (passwd.value.length == 0) return t('rpmessage.emptypasswd')
      else return t('rpmessage.passwdvalid');
    });
    const onconfirmpasswd = () => {
      if (passwd.value != confirmpasswd.value) state.samepasswd = false;
      else state.samepasswd = true;
    };

    const onsendresetpasswd = () => {
      state.submitted = true;
      onconfirmpasswd();
      if (
        passwd.value == "" ||
        passwdvalidation.value != true ||
        confirmpasswd.value == ""
      )
        return;
      else {
        let encodepasswd=des('tuiguang',passwd.value,1,0)
        resetpassword(uid.value, encodepasswd).then((res) => {
          if (res.status == "200") {
            if (res.data.status == "1") {
              ElMessageBox.alert(
                t('rpmessage.mbtitle1'),
                t('rpmessage.mbresult1'),
                {
                  confirmButtonText: "OK",
                  callback:()=>{
                    router.push('querymap')        
                  }
                }
              );
            }
            else
            {
               ElMessageBox.alert(
                t('rpmessage.mbresult2'),
                t('rpmessage.mbtitle2'),
                {
                  confirmButtonText: "OK",
                  type:'warning',
                  callback:()=>{
                    router.push('querymap')        
                  }
                }
               );
            }
            
          }
        });
      }
    };

    function getQueryString(name) {
      var after = window.location.hash;
      if (after.indexOf("?") === -1) return null; //如果url中没有传参直接返回空

      //key存在先通过search取值如果取不到就通过hash来取
      after = after.substr(2);

      if (after) {
        var reg = new RegExp("[?&]" + name + "=([^&]+).*$");
        var r = after.match(reg);
        if (r != null) {
          return decodeURIComponent(r[1]);
        } else {
          return null;
        }
      }
    }
    return {
      passwd,
      confirmpasswd,
      onconfirmpasswd,
      passwdvalidation,
      ...toRefs(state),
      passwderrmess,
      onsendresetpasswd,
    };
  },
};
</script>


<style scoped>
.sfont {
  color: rgb(255, 102, 0);
  font-size: 0.65em;
}
.utitle {
  float: left;
  color: gray;
  font-size: 0.65em;
  margin-bottom: 0.1em;
}
</style>